export const DEFAULT_ICON_SET = "fa-solid";

export const STRAIN = "fa-seedling";

export const ARCHIVE = "fa-archive";
